module.exports = __webpack_public_path__ + "img/222A1690.08c5a467.png";